import { trans } from '@spotahome/soyuz/client';

import './modals.scss';

export const canShowModal = rule =>
  rule?.landlordBirthday || rule?.landlordGender;

const LandlordLivesInHouseModal = ({ rule }) => {
  const bodyContent = [
    rule?.landlordBirthday ? (
      <div className="property-rules-modal__section" key="birthday">
        <p className="property-rules-modal__section-title">
          {trans('property.rule.feature.landlordLivesInHouse.birthdate')}
        </p>
        <p className="property-rules-modal__section-content">
          {rule?.landlordBirthday}
        </p>
      </div>
    ) : null,
    rule?.landlordGender ? (
      <div className="property-rules-modal__section" key="gender">
        <p className="property-rules-modal__section-title">
          {trans('property.rule.feature.landlordLivesInHouse.gender')}
        </p>
        <p className="property-rules-modal__section-content">
          {trans(
            `property.rule.feature.landlordLivesInHouse.${rule?.landlordGender}`
          )}
        </p>
      </div>
    ) : null
  ].filter(Boolean);

  return <div className="property-rules-modal">{bodyContent}</div>;
};

export default LandlordLivesInHouseModal;
